module.exports = "/packs/pattern-left-pink-3fb6fdf4d1e643b5530db78a8055970e.png";